import type { PricelistPeriod } from "@/generated/graphql";
import { toast } from "@k3-tech/react-kit";
import { PricelistPeriodList } from "../components/PricelistPeriodList";
import { usePricelistPeriodList } from "../usecases/usePricelistPeriodList";

export const PricelistPeriodListContainer = ({
  pricelistID,
}: {
  pricelistID?: string;
}) => {
  const {
    data,
    fetching,
    load,
    deletePricelistPeriod,
    paginationState,
    setPagination,
    setFilters,
  } = usePricelistPeriodList({
    page: 1,
    pageSize: 10,
    withCount: true,
    pricelistID,
  });

  const onDelete = async (data: Partial<PricelistPeriod>) => {
    const result = await deletePricelistPeriod({ pricelistPeriodID: data.pricelistPeriodID });
    if (!result.error) {
      toast.success("Pricelist Period deleted");
      load();
    }
  };

  const onFormFilterChange = (values: Record<string, unknown>) => {
    const status = values.status as boolean | undefined;

    values.isActive = status;

    const { status: _, ...others } = values;
    setFilters({ ...others });
  };

  return (
    <PricelistPeriodList
      pricelistID={pricelistID}
      data={(data?.pricelistPeriods?.items as never) ?? []}
      loading={fetching}
      onRefresh={() => load()}
      onDelete={(data) => onDelete(data)}
      onFormFilterChange={onFormFilterChange}
      paginationState={paginationState}
      onPaginationChange={setPagination}
      rowCount={data?.pricelistPeriods?.pagination?.totalRows}
    />
  );
};
